
import store from "@/store";
import CornerstoneMZYL from "@/utils/cornerstoneMZYL"
class StackDrag {
  constructor() {
    //
    this.SLICE = 5; // 分割规则
    /**
     * @description 原始数据分割
     * */

    this._dataCarveUpResult = [];
    /**
     * @description 加载dcm二维数组的下标
     * */

    this._newImageIdIndexToSliceIndex = 0;
    this._dragIndex = 0;
    // this._internalIndex = 0; // 内部小循环的下表
    this._rootVue = null;
    this.events = {};
     /**
     * @description 计划加载dcm数据的队列
     * */
    this._DCMLoaderQueue = []
  }
  static getInstance() {
    if (!StackDrag.instance) {
      StackDrag.instance = new StackDrag();
      return StackDrag.instance;
    }
    return new StackDrag();
  }
  set newImageIdIndexToSliceIndex(index) {
    this._newImageIdIndexToSliceIndex = index;
  }
  init() {
    // 处理数据
    this.dataCarveUp();
    // 加载dcm
    this.autoLoadImage();
  }
  mixin(rootVue) {
    const pathname = location.pathname.split("/")[1]
    const imageBrowsing = store.getters[pathname];
    const thumbnailSeriesIndex = CornerstoneMZYL.seriesIndex
    this._rootVue = rootVue;
    this._list = imageBrowsing[thumbnailSeriesIndex];
    this._list.percentage = this._list.percentage || 0;
    this._getDcmFilePath = imageBrowsing[thumbnailSeriesIndex].getDcmFilePath;
  }
  //数据分割
  dataCarveUp() {
    const _result = this._getDcmFilePath.flatMap((value, index, array) => {
      if (index % this.SLICE === 0) {
        return [array.slice(index, index + this.SLICE)];
      }
      return [];
    });
    this._dataCarveUpResult = _result;
  }
  // 加载数据
  autoLoadImage() {
    console.log("autoLoadImage加载");
    // 如果鼠标拖拽终止执行
    if (store.getters.stackDragState) {
      // console.log("onStackdragevent2拖拽鼠标停止加载");
      return;
    }
    // 如果数据下载完终止执行
    if (this._newImageIdIndexToSliceIndex >= this._dataCarveUpResult.length) {
      // console.log(' this._list ', this._list )
      console.log("数据下载完成终止执行");
      this._DCMLoaderQueue.shift()
      if(this._DCMLoaderQueue.length > 0){
        // console.log("已经存在队列",this._DCMLoaderQueue);
        // 如果当前队列的value和序列下标 ActiveSeriesIndex 相同 这shift 
          this._newImageIdIndexToSliceIndex = 0
          this.mixin(this._rootVue,0,this._DCMLoaderQueue[0])
          this.init()
      }
      return;
    }
    // 每个内部小循环初始化是 0 ；
    let _internalIndex = 0;
    let _this = this;

    this._dataCarveUpResult[this._newImageIdIndexToSliceIndex].forEach(
      (imageId, index) => {
        cornerstone.loadAndCacheImage(imageId).then(image => {
          // 响应请求之后 +1
          _internalIndex += 1;

          //进度条组件
          //记录 list 的长度
          
          if (_this._list.percentage < _this._getDcmFilePath.length) {
            this._list.percentage +=1
            // console.log(_this._rootVue)
            // _this._rootVue.$refs.thumbnailWrapper[
            //   _this._rootVue.activeViewerMainLayout
            // ] &&
            //   _this._rootVue.$refs.thumbnailWrapper[
            //     _this._rootVue.activeViewerMainLayout
            //   ].$forceUpdate();
          }

          // console.log("进度条监听", _this._list.percentage);
          if (this._dataCarveUpResult[this._newImageIdIndexToSliceIndex]) {
            if (
              _internalIndex == _this.SLICE ||
              this._dataCarveUpResult[this._newImageIdIndexToSliceIndex]
                .length < _this.SLICE
            ) {
              // 都需要 + 1 因为拖拽的时候调整的是数组，下标没有变化
              _this._newImageIdIndexToSliceIndex++;
              // 继续加载
              this.autoLoadImage();
            } else {
              return;
            }
          }
        });
      }
    );
  }
  // 拖拽加载
  Stackdragevent(ev) {
    store.dispatch("updateStackDragState", true);
    const { newImageIdIndex } = ev.detail;
    this._dragIndex = Math.floor(newImageIdIndex / this.SLICE);
    // console.log('当前dcm文件所匹配的下标', this._dragIndex)
    this.autoLoadImage();
  }
  // 监听鼠标up事件
  Stackdragupevent(ev) {
    // console.log('Stackdragupevent抬起的index',this._dragIndex)
    // console.log('已经加载的index',this._newImageIdIndexToSliceIndex)
    // console.log('_dataCarveUpResult的长度',this._dataCarveUpResult.length)

    if (this._dragIndex <= this._newImageIdIndexToSliceIndex) {
      store.dispatch("updateStackDragState", false);
      this.autoLoadImage();
    } else {
      this._newImageIdIndexToSliceIndex = this._dragIndex;
      store.dispatch("updateStackDragState", false);
      this.autoLoadImage();
    }
    // console.log(ev)
  }
  // 添加监听器
  addListener(eventName, listener) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(listener);
  }
  // 触发事件
  trigger(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(listener => {
        listener(...args);
      });
    }
  }
  // 队列
  addQueue(index){
    this._DCMLoaderQueue.push(index)
  }
  resetQueue(){
    this._DCMLoaderQueue = []
  }
}

export default StackDrag.getInstance();
